import BasePage from '../../components/base-page/base-page';

import type { UiElement } from '../../../shared/ui-element/ui-element';

import './ios-vendors-landing.scss';

export const ERROR_COLOR = '#ff2c47';
export const VALID_COLOR = '#26262b';

const ERROR_CLASS_NAME = 'ios-vendors-form-block__input-error';

class IosVendorsLanding extends BasePage {
  ui = {
    form: '.js-ios-vendors-form',
    submitButton: '.js-ios-vendors-submit-btn',
    successMessageBlock: '.js-ios-vendors-success-message-block',
    nameInput: '.js-ios-vendors-name-input',
    emptyNameErrorMessage: '.js-ios-vendors-error-empty-name-input',
    companyInput: '.js-ios-vendors-company-input',
    emptyCompanyErrorMessage: '.js-ios-vendors-error-empty-company-input',
    websiteInput: '.js-ios-vendors-website-input',
    emptyWebsiteErrorMessage: '.js-ios-vendors-error-empty-website-input',
    notWebsiteErrorMessage: '.js-ios-vendors-error-not-website',
    emailInput: '.js-ios-vendors-email-input',
    emptyEmailErrorMessage: '.js-ios-vendors-error-empty-email-input',
    notEmailErrorMessage: '.js-ios-vendors-error-not-email',
    checkBox: '.js-ios-vendors-checkbox',
    checkBoxLabel: '.js-ios-vendors-checkbox-label',
    checkBoxErrorMessage: '.js-ios-vendors-checkbox-error-message',
  };

  uiCollections = {
    formInputs: '.js-ios-vendors-input',
  };

  events = {
    'submit @ui.form': 'handleFormSubmit',
    'click @ui.submitButton': 'handleFormValidationClick',
  };

  onInit() {
    super.onInit();
  }

  validationInput = (inputName, emptyErrorContainer, invalidValueErrorContainer) => {
    const input = (this.ui[inputName] as unknown as HTMLInputElement);
    const emptyErrorMessage = (this.ui[emptyErrorContainer] as unknown as HTMLElement);
    const notValidMessage = (this.ui[invalidValueErrorContainer] as unknown as HTMLElement);

    const isValid = input.reportValidity();

    input.classList.remove(ERROR_CLASS_NAME);
    notValidMessage.style.display = 'none';
    emptyErrorMessage.style.display = 'none';

    if (!isValid) {
      input.classList.add(ERROR_CLASS_NAME);
      (input.value.trim() ? notValidMessage : emptyErrorMessage).style.display = 'inline';
    }
  };

  validationCheckbox = () => {
    const checkBox = (this.ui.checkBox as unknown as HTMLFormElement);
    const checkBoxLabel = (this.ui.checkBoxLabel as unknown as HTMLFormElement);
    const checkBoxErrorMessage = (this.ui.checkBoxErrorMessage as unknown as HTMLElement);

    const isValid = checkBox.checked;

    checkBoxLabel.style.borderColor = isValid ? VALID_COLOR : ERROR_COLOR;
    checkBoxErrorMessage.style.display = isValid ? 'none' : 'inline';
  };

  validationStringInput = (inputName, errorContainerName) => {
    const input = (this.ui[inputName] as unknown as HTMLInputElement);
    const errorContainerMessage = (this.ui[errorContainerName] as unknown as HTMLElement);

    if (input.value.trim() && input.checkValidity()) {
      input.classList.remove(ERROR_CLASS_NAME);
      errorContainerMessage.style.display = 'none';
    } else {
      input.classList.add(ERROR_CLASS_NAME);
      errorContainerMessage.style.display = 'inline';
    }
  };

  validationNameInput = () => {
    this.validationStringInput('nameInput', 'emptyNameErrorMessage');
  };

  validationCompanyInput = () => {
    this.validationStringInput('companyInput', 'emptyCompanyErrorMessage');
  };

  validationWebsiteInput = () => {
    this.validationInput('websiteInput', 'emptyWebsiteErrorMessage', 'notWebsiteErrorMessage');
  };

  validationEmailInput = () => {
    this.validationInput('emailInput', 'emptyEmailErrorMessage', 'notEmailErrorMessage');
  };

  handleFormValidationClick = () => {
    this.validationNameInput();
    this.validationCompanyInput();
    this.validationWebsiteInput();
    this.validationEmailInput();
    this.validationCheckbox();
  };

  handleTrimInputValue = () => {
    (this.uiCollections.formInputs as unknown as HTMLInputElement[]).forEach((input) => {
      input.value = input.value.trim();
    });

    [this.ui.emailInput, this.ui.websiteInput].forEach((input) => {
      (input as unknown as HTMLInputElement).value = (input as unknown as HTMLInputElement).value.toLowerCase();
    });
  };

  handleFormSubmit = () => {
    const form = (this.ui.form as unknown as HTMLFormElement);
    const successMessageBlock = (this.ui.successMessageBlock as unknown as HTMLElement);

    this.handleTrimInputValue();

    successMessageBlock.style.display = 'flex';
    form.style.display = 'none';
  };
}

export default IosVendorsLanding;

(IosVendorsLanding as UiElement).initOnDomLoaded();
